export default function SectionLabel({ children }) {
  return (
    <div className="text-[11px] font-bold tracking-[0.24em] uppercase text-teal-600 mb-3">
      {children}
    </div>
  );
}
